var mvvm = {};
mvvm._requestsInProgress = 0;
mvvm._requestsQueue = new Array();
mvvm._ajaxCallbacks = new Array();
mvvm.IsMVVMRequest = false;

mvvm.reset = function ()
{
	mvvm.doSubmit(null, '__RESET', null);
}

mvvm.doSubmit = function(eventSrc, eventName, eventArg, callback, callbackArg){
	if (mvvm._requestsInProgress > 0) {
		mvvm._requestsQueue.push({ EventSrc: eventSrc, EventName: eventName, EventArg: eventArg, Callback: callback, CallbackArg: callbackArg });
		return;
	}

	var form = $("#mvvmForm, #mvvm-form")[0]; //document.forms[0];
	if (typeof(CKEDITOR) != 'undefined') {
		for (var instance in CKEDITOR.instances)
			CKEDITOR.instances[instance].updateElement();
	}
	var eventSrcControl = document.getElementById("__EVENTSRC");
	var eventNameControl = document.getElementById("__EVENTNAME");
	var eventArgControl = document.getElementById("__EVENTARG");
	var updatePanelNameControl = document.getElementById("__UPDATEPANEL");

	eventSrcControl.value = eventSrc != null ? eventSrc : "";
	eventNameControl.value = eventName != null ? eventName : "";
	eventArgControl.value = eventArg != null ? eventArg : "";

	var sender = null;
	if (eventSrc != null) {
		sender = document.getElementById(eventSrc); // $("#" + eventSrc);
		if (sender != null && sender.getAttribute("data-form-always-enable") == null) {
			if ((sender.tagName.toLowerCase() == "input" && sender.type == "button") || sender.tagName.toLowerCase() == "button") {
				sender.disabled = true;
			} else if (sender.tagName.toLowerCase() == "input") {
				sender.readOnly = true;
			}
		}
	}

	mvvm._requestsInProgress++;

	var currentRequest = new XMLHttpRequest();
	currentRequest.open('POST', window.location.href, true);
	currentRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
	currentRequest.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

	var csrf = $('meta[name="csrf-token"]').attr('content');
	var nonce = $('meta[name="csp-nonce"]').attr('content');
	if (csrf) currentRequest.setRequestHeader('X-CSRF-TOKEN', csrf);
	if (nonce) currentRequest.setRequestHeader('X-CSP-Nonce', nonce);

	var panels = new Array();
	panels.push($("#update-panel, #UpdatePanel")[0]);

	var progressPanels = new Array();
	var progress = $("#GlobalProgressPanel");
	progress.show();
	progressPanels.push(progress);

	$(form).addClass('loading');

	var handler = new mvvm.requestHandler(currentRequest, panels, progressPanels, sender, callback, callbackArg);
	currentRequest.onreadystatechange = function () {
		return handler.onRequestComplete.apply(handler, null);
	};
	currentRequest.send(mvvm.getFormInputsForRequest(form));

	updatePanelNameControl.value = "";

	eventSrcControl.value = "";
	eventNameControl.value = "";
	eventArgControl.value = "";
}

mvvm.getFormInputsForRequest = function (form) {
	var request = new Array();
	var count = 0;
	for (var i = 0; i < form.elements.length; i++) {
		const element = form.elements[i];
		if (element.name == "")
			continue;
		if (mvvm.isCheckboxOrRadio(element)) {
			if (element.checked) {
				request[count++] = element.name + "=" + encodeURIComponent(element.value);
			}
		} else {
			request[count++] = element.name + "=" + encodeURIComponent(element.value);
		}
	}
	return request.join("&");
}

mvvm.requestHandler = function (request, updatePanels, progressPanels, sender, callback, callbackArg) {
	this._request = request;
	this._updatePanel = updatePanels;
	this._progressPanels = progressPanels;
	this._sender = sender;
	this._callback = callback;
	this._callbackArg = callbackArg;

	this.onRequestComplete = function () {
		if (this._request.readyState == 4) {
			if (this._request.status == 200) {
				var panelLookup = new Array();
				for (var i = 0; i < this._updatePanel.length; i++) {
					panelLookup[this._updatePanel[i].id] = this._updatePanel[i];
				}
				var responseText = this._request.responseText.toString();
				while (responseText.substring(0, 3) == "###") {
					var newlinePosition = responseText.indexOf("\n");
					if (newlinePosition == -1)
						newlinePosition = responseText.length;
					var header = responseText.substring(3, newlinePosition);
					if (header.substring(0, 9) == "Location:") {
						var url = header.substring(9);
						if (url == "")
							window.location.href = window.location.href;
						else
							window.location.href = url;
						if (url.indexOf('mailto:') == -1) {
							// !IMPORTANT Това ще игнорира цялата опашка!
							return;
						}
					} else if (header.substring(0, 6) == "Blank:") {
						var url = header.substring(6);
						window.open(url, "_blank");
					}
					responseText = responseText.substring(newlinePosition + 1);
				}
				var responses = responseText.split("|||");
				if ((responses.length % 2) === 0) {
					var scrollTop = $(document).scrollTop();
					for (var i = 0; i < responses.length; i = i + 2) {
						var content = responses[i];
						var panelName = responses[i + 1];
						if (panelLookup[panelName]) {
							$(panelLookup[panelName]).html(content);
						}
					}
					$(document).scrollTop(scrollTop);
					$(document).trigger("mvvm:updated");
				} else {
					alert("An unexpected error occured. Try again and if the issue persists, try refreshing the page.");
				}
			} else if (this._request.status == 500) {
				var r = /<title>\s*((.[\n\r]?)+?)\s*<\/title>/i;
				var m = r.exec(this._request.responseText);
				if (m[1]) {
					var span = document.createElement("span");
					span.innerHTML = m[1];
					alert(span.innerText);
				} else {
					alert("An error occured while completing the request.");
				}
			}
			mvvm._requestsInProgress--;

			if (this._sender != null) {
				if (this._sender.getAttribute("data-form-always-enable") == null && (this._sender.disabled || this._sender.readOnly)) {
					if ((this._sender.tagName.toLowerCase() == "input" && this._sender.type == "button") || this._sender.tagName.toLowerCase() == "button") {
						this._sender.disabled = false;
					} else if (this._sender.tagName.toLowerCase() == "input") {
						this._sender.readOnly = false;
					}
				}
			}
			for (var j = 0; j < this._progressPanels.length; j++) {
				//this._progressPanels[j].hide();
				if(this._progressPanels[j].length > 0)
					this._progressPanels[j][0].style.display = "none";
			}

			$("#mvvmForm, #mvvm-form").removeClass('loading');

			if (typeof (this._callback) == 'function') {
				this._callback(this._callbackArg);
			}
			for (var i = 0; i < mvvm._ajaxCallbacks.length; i++) {
				mvvm._ajaxCallbacks[i]();
			}

			if (mvvm._requestsInProgress == 0) {
				if (mvvm._requestsQueue.length > 0) {
					var obj = mvvm._requestsQueue.shift();
					// console.log("Popped a request from queue: " + "EventSrc=" + obj.EventSrc + "; EventName=" + obj.EventName + "; EventArg=" + obj.EventArg + "");
					mvvm.doSubmit(obj.EventSrc, obj.EventName, obj.EventArg, obj.Callback, obj.CallbackArg);
				}
			}
		}
	}
}

mvvm.isCheckboxOrRadio = function(element) {
	return element.tagName.toLowerCase() == "input" && (element.type == "checkbox" || element.type == "radio");
}

$(document).on('click', '[data-mvvm-submit]', function(e) {
	var $this = $(this);
	var confirmMsg = $this.attr('data-mvvm-confirm');
	if (confirmMsg && !confirm(confirmMsg)) {
		e.preventDefault();
		return false;
	}

	var eventSrc = $this.attr('data-mvvm-src') || null;
	if (eventSrc === 'this.id') eventSrc = this.id;
	if (eventSrc === 'null' || eventSrc === '') eventSrc = null;
	var eventName = $this.attr('data-mvvm-submit');
	var eventArg = $this.attr('data-mvvm-arg') || null;
	if (eventArg === 'null' || eventArg === '') eventArg = null;

	var callback = null;
	var callbackArg = null;

	if (eventArg != null && eventArg.indexOf(", function(){") != -1) {
		var parts = eventArg.split(", function(){");
		eventArg = parts[0].trim();
		callback = new Function("return function(){" + parts[1])();
		callbackArg = null;
	}

	if (eventArg != null && ((eventArg.startsWith("'") && eventArg.endsWith("'")) || (eventArg.startsWith('"') && eventArg.endsWith('"')))) {
		eventArg = eventArg.substring(1, eventArg.length - 1);
	}

	mvvm.doSubmit(eventSrc, eventName, eventArg, callback, callbackArg);
	e.preventDefault();
});

$(document).on('click', '[data-mvvm-action]', function (e) {
	var $this = $(this);
	var confirmMsg = $this.attr('data-mvvm-confirm');
	if (confirmMsg && !confirm(confirmMsg)) {
		e.preventDefault();
		return false;
	}

	var action = $this.attr('data-mvvm-action');
	var arg1 = $this.attr('data-mvvm-arg') || $this.attr('data-arg1');
	var arg2 = $this.attr('data-arg2');
	var arg3 = $this.attr('data-arg3');
	var src = $this.attr('data-mvvm-src') || null;
	if (src === 'this.id') src = this.id;
	if (src === 'null' || src === '') src = null;

	if (action.indexOf('.') !== -1) {
		var parts = action.split('.');
		var obj = window[parts[0]];
		if (obj && typeof obj[parts[1]] === 'function') {
			obj[parts[1]](this, arg1, arg2, arg3);
		}
	} else if (typeof window[action] === 'function') {
		try {
			window[action](this, arg1, arg2, arg3);
		} catch (e) {
			if (e instanceof TypeError && (e.message.indexOf('class') !== -1 || e.message.indexOf('constructor') !== -1)) {
				var instance = new window[action]();
				if (typeof instance.open === 'function') {
					instance.open(arg1, arg2, arg3);
				}
			} else {
				throw e;
			}
		}
	} else if (typeof mvvm[action] === 'function') {
		mvvm[action](src, arg1, arg2, arg3);
	} else {
		var callback = null;
		var callbackArg = null;
		if (arg1 != null && typeof arg1 === 'string' && arg1.indexOf(", function(){") != -1) {
			var parts = arg1.split(", function(){");
			arg1 = parts[0].trim();
			if ((arg1.startsWith("'") && arg1.endsWith("'")) || (arg1.startsWith('"') && arg1.endsWith('"'))) {
				arg1 = arg1.substring(1, arg1.length - 1);
			}
			callback = new Function("return function(){" + parts[1])();
			callbackArg = null;
		}
		mvvm.doSubmit(src, action, arg1, callback, callbackArg);
	}
	e.preventDefault();
	e.stopImmediatePropagation();
});
